module.exports = __webpack_public_path__ + "img/10.3cd47bd8.png";